//
// Telemetry.
function ANTelemetry(sessionId = null){

    this.TYPE_DATA  = 'data';
    this.TYPE_ERROR = 'error';

    this.__logger                  = new AdsNinjaLogger();
    this.__baseUrl                 = 'https://telemetry.adsninja.ca';
    this.__errorEndpoint           = 'error.php';
    this.__dataEndpoint            = 'data.php';
    this.__clientData              = null;
    this.__chosenAdSetup           = null;
    this.__chosenAdSetupKeyDetails = null;
    this.__brandName               = null;
    this.__environment             = null;
    this.__pageGamId               = null;
    this.__isBoosted               = null;
    this.__errorSampleRate         = 0;  // TODO: Turn off for now. Need to revisit.
    this.__dataSampleRate          = 1;
    this.__errorTelemetryEnabled   = this.__determineTelemetryEnabled(this.__errorSampleRate);
    this.__telemetryLogger         = new ANTelemetryLogger(this, this.__errorTelemetryEnabled);
    this.__sessionId               = sessionId;
}

//
// Determine if error telemetry is enabled.
ANTelemetry.prototype.isErrorTelemetryEnabled = function(){

    return (this.__errorTelemetryEnabled);
};

//
// Returns the telemetry logger.
// To be used by classes that want to log telemetry to the server.
// Should be different from the logger used by this class to avoid infinite loops.
ANTelemetry.prototype.getLogger = function(){
    
    return this.__telemetryLogger;
}

//
// Get order of magnitude.
ANTelemetry.prototype.__determineTelemetryEnabled = function(sampleRate){

    // Get order of magnitude to determine how many zeros in sample rate.
    var orderOfMagnitude = this.__getOrderOfMagnitude(sampleRate);

    if(orderOfMagnitude >= 0){

        return true;
    }

    var exponent   = Math.max(2, Math.abs(this.__symmetricRound(orderOfMagnitude)));
    var powerOfTen = Math.pow(10, exponent);

    return ((sampleRate * powerOfTen) >= this.__getRandomInt(1, powerOfTen));
};

//
// Get order of magnitude.
ANTelemetry.prototype.__getOrderOfMagnitude = function(num){

    // return Math.floor(Math.log10(num));
    return Math.floor(Math.log(num) / Math.log(10));
};

//
// Get random integer.
ANTelemetry.prototype.__getRandomInt = function(min, max){
    
    return Math.floor(Math.random() * (max - min + 1) + min);
};

//
// Symmetric round. Round half away from zero.
// Rounds up if positive, rounds down if negative.
ANTelemetry.prototype.__symmetricRound = function(num){

    // return Math.sign(num) * Math.round(Math.abs(num));
    return ((num >= 0) ? 1 : -1) * Math.round(Math.abs(num));
};

//
// Get page GAM ID.
ANTelemetry.prototype.__getPageGamId = function(){
    
    if(null === this.__pageGamId){    
        
        this.__pageGamId = (window.adsNinjaHeaderBiddingManager.hasOwnProperty('__pageGamId')) ? window.adsNinjaHeaderBiddingManager.__pageGamId : null;    
    }

    return this.__pageGamId;
};

//
// Returns true if page is being boosted.
ANTelemetry.prototype.__isPageBoosted = function(){
    
    if(null !== this.__isBoosted){

        var boostingUrlData = window.adsNinjaHeaderBiddingManager.__boostingUrlData;

        if(boostingUrlData && typeof boostingUrlData === 'object' &&boostingUrlData['boostNow']){

            this.__isBoosted = true;
        }
    }

    return this.__isBoosted;
}

//
// Get client data.
ANTelemetry.prototype.__getClientData = function(clientDataParamsToNotInclude = []){
    
    if(null === this.__clientData){

        this.__clientData                 = JSON.parse(JSON.stringify(window.adsNinjaHeaderBiddingManager.getClientData()));
        this.__clientData['bN']           = clientDataParamsToNotInclude.indexOf('brandName') == -1  ? this.__clientData['brandName'] : null;
        this.__clientData['env']          = clientDataParamsToNotInclude.indexOf('environment') == -1  ? this.__clientData['environment'] : null; 
        this.__clientData['dT']           = clientDataParamsToNotInclude.indexOf('deviceType') == -1  ? this.__clientData['deviceType'] : null; 
        this.__clientData['tmpl']         = clientDataParamsToNotInclude.indexOf('template') == -1  ? this.__clientData['template'] : null; this.__clientData['template'];
        this.__clientData['ntwkCat']      = clientDataParamsToNotInclude.indexOf('networkCategory') == -1  ? this.__clientData['networkCategory'] : null; this.__clientData['networkCategory'];
        this.__clientData['cntT']         = clientDataParamsToNotInclude.indexOf('contentType') == -1  ? this.__clientData['contentType'] : null; this.__clientData['contentType'];
        this.__clientData['src']          = clientDataParamsToNotInclude.indexOf('source') == -1  ? this.__clientData['source'] : null; this.__clientData['source'];
        this.__clientData['geo']          = clientDataParamsToNotInclude.indexOf('geo') == -1  ? this.__clientData['geo'] : null; this.__clientData['geo'];
        this.__clientData['cC']           = clientDataParamsToNotInclude.indexOf('consentContext') == -1  ? this.__clientData['consentContext'] : null; this.__clientData['consentContext'];
        this.__clientData['cN']           = clientDataParamsToNotInclude.indexOf('consentNeeded') == -1  ? this.__clientData['consentNeeded'] : null; this.__clientData['consentNeeded'];
        this.__clientData['ext']          = clientDataParamsToNotInclude.indexOf('extraParams') == -1  ? this.__clientData['extraParams'] : null; this.__clientData['extraParams'] || {};
        this.__clientData['ext']['lTC']   = (clientDataParamsToNotInclude.indexOf('loginToContinue') == -1 && this.__clientData['ext'] && 'undefined' !== typeof this.__clientData['ext']['loginToContinue']) ? this.__clientData['ext']['loginToContinue'] : null;
        this.__clientData['ext']['osFam'] = (clientDataParamsToNotInclude.indexOf('osFamily') == -1 && this.__clientData['ext'] && this.__clientData['ext']['osFamily']) ? this.__clientData['ext']['osFamily'] : null;
        this.__clientData['ext']['sCat']  = (clientDataParamsToNotInclude.indexOf('siteCategory') == -1 && this.__clientData['ext'] && this.__clientData['ext']['siteCategory']) ? this.__clientData['ext']['siteCategory'] : null;
        this.__clientData['gamId']        = clientDataParamsToNotInclude.indexOf('pageGamId') == -1  ? this.__clientData['pageGamId'] : null; this.__clientData['pageGamId'];
        this.__clientData['boost']        = clientDataParamsToNotInclude.indexOf('isBoosted') == -1  ? this.__clientData['isBoosted'] : null; this.__clientData['isBoosted'];
        this.__clientData['s']            = clientDataParamsToNotInclude.indexOf('sessionId') == -1  ? this.__clientData['sessionId'] : null; this.__clientData['sessionId'];
        this.__clientData['abc']          = clientDataParamsToNotInclude.indexOf('isAdBlockConverted') == -1  ? this.__clientData['isAdBlockConverted'] : null; this.__clientData['isAdBlockConverted'];

        for(var x in this.__clientData){

            if(this.__clientData[x] === null || this.__clientData[x] === undefined){

                delete this.__clientData[x];
            }
        }

        if(clientDataParamsToNotInclude.indexOf('url') != -1){

            delete this.__clientData['url'];
        }

        delete this.__clientData['brandName'];
        delete this.__clientData['environment'];
        delete this.__clientData['deviceType'];
        delete this.__clientData['template'];
        delete this.__clientData['networkCategory'];
        delete this.__clientData['contentType'];
        delete this.__clientData['source'];
        delete this.__clientData['isEuTraffic'];
        delete this.__clientData['consentContext'];
        delete this.__clientData['consentNeeded'];
        delete this.__clientData['extraParams'];
        delete this.__clientData['pageGamId'];
        delete this.__clientData['isBoosted'];
        delete this.__clientData['sessionId'];
        delete this.__clientData['isAdBlockConverted'];

        

        if(this.__clientData['ext']){

            delete this.__clientData['ext']['loginToContinue'];
            delete this.__clientData['ext']['osFamily'];
            delete this.__clientData['ext']['siteCategory'];
        }
    }

    return this.__clientData;
};

//
// Get chosen ad setup data.
ANTelemetry.prototype.__getChosenAdSetup = function(){
    
    if(!this.__chosenAdSetup){

        this.__chosenAdSetup            = JSON.parse(JSON.stringify(window.adsNinjaHeaderBiddingManager.getChosenAdSetup()));
        this.__chosenAdSetup['created'] = this.__chosenAdSetup['createdDate'];
        this.__chosenAdSetup['updated'] = this.__chosenAdSetup['updatedDate'];
        this.__chosenAdSetup['info']    = this.__chosenAdSetup['keyDetails'];
    
        delete this.__chosenAdSetup['createdDate'];
        delete this.__chosenAdSetup['updatedDate'];
        delete this.__chosenAdSetup['keyDetails'];
    }

    return this.__chosenAdSetup;
};

//
// Get chosen ad setup key details.
ANTelemetry.prototype.__getChosenAdSetupKeyDetails = function(){
    
    if(!this.__chosenAdSetupKeyDetails){

        this.__chosenAdSetupKeyDetails            = JSON.parse(JSON.stringify(window.adsNinjaHeaderBiddingManager.getChosenAdSetupKeyDetails()));
        this.__chosenAdSetupKeyDetails['dT']      = this.__chosenAdSetupKeyDetails['deviceType'];
        this.__chosenAdSetupKeyDetails['tmpl']    = this.__chosenAdSetupKeyDetails['template'];
        this.__chosenAdSetupKeyDetails['ntwkCat'] = this.__chosenAdSetupKeyDetails['networkCategory'];
        this.__chosenAdSetupKeyDetails['cntT']    = this.__chosenAdSetupKeyDetails['contentType'];
        this.__chosenAdSetupKeyDetails['src']     = this.__chosenAdSetupKeyDetails['source'];
        this.__chosenAdSetupKeyDetails['geo']     = this.__chosenAdSetupKeyDetails['geo'];

        delete this.__chosenAdSetupKeyDetails['deviceType'];
        delete this.__chosenAdSetupKeyDetails['template'];
        delete this.__chosenAdSetupKeyDetails['networkCategory'];
        delete this.__chosenAdSetupKeyDetails['contentType'];
        delete this.__chosenAdSetupKeyDetails['source'];
    }

    return this.__chosenAdSetupKeyDetails;
}

//
// Get brand name.
ANTelemetry.prototype.__getBrandName = function(){
    
    if(!this.__brandName){

        var clientData   = this.__getClientData();
        this.__brandName = (!clientData && !clientData['brandName'] && !clientData['bN']) ? 'Unknown' : clientData['bN'] || clientData['brandName'];
    }

    return this.__brandName;
};

//
// Get environment.
ANTelemetry.prototype.__getEnvironment = function(){

    if(!this.__environment){

        var clientData     = this.__getClientData();
        this.__environment = (!clientData && !clientData['environment'] && !clientData['env']) ? 'Unknown' : clientData['env'] || clientData['environment'];
    }

    return this.__environment;
};

//
// Encode message body.
ANTelemetry.prototype.__encodeMessageBody = function(data){

    if(data){
        
        try{

            data = JSON.stringify(data);
        }
        catch(error){

            try{

                data = JSON.stringify(data, this.__getCircularReplacer());
            }
            catch(error){

                this.__logger.warn('Unable to stringify data.', data, false);

                data = null;
            }
        }
    }
    else{

        data = null;
    }

    return data;
};

//
// Send data.
ANTelemetry.prototype.send = function(type, message, data = null, successCallback = null, errorCallback = null, useBeacon = false, includeChosenAdSetup = true, clientDataParamsToNotInclude = [], includeMessage = true, recordingOptions = {}){
    
    var brandName               = this.__getBrandName();
    var dataTelemetryEnabled    = true; // this.__determineTelemetryEnabled(this.__dataSampleRate);
    var isSendingDataTelemetry  = (this.TYPE_DATA === type && dataTelemetryEnabled);
    var isSendingErrorTelemetry = (this.TYPE_ERROR === type && this.__errorTelemetryEnabled);

    if((!isSendingDataTelemetry && !isSendingErrorTelemetry)){

        this.__logger.debug('Telemetry is disabled.', {
            dataTelemetryEnabled: dataTelemetryEnabled,
            errorTelemetryEnabled: this.__errorTelemetryEnabled,
            brandName: brandName,
            type: type,
            message: message,
            data: data,
        }, false);

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(null, null, true);
        }

        return;
    }

    if(!type || !message){

        this.__logger.warn('Unable to send data: missing message or type.', {
            dataTelemetryEnabled: dataTelemetryEnabled,
            errorTelemetryEnabled: this.__errorTelemetryEnabled,
            brandName: brandName,
            message: message,
            type: type,
            data: data,
        }, false);

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(null, null, false);
        }

        return;
    }

    var endpoint = '';

    switch(type){

        case 'data':

            endpoint = this.__dataEndpoint;

            break;

        case 'error':

            endpoint = this.__errorEndpoint;

            break;

        default:

            this.__logger.error('Unable to send data: invalid type.', {
                dataTelemetryEnabled: dataTelemetryEnabled,
                errorTelemetryEnabled: this.__errorTelemetryEnabled,
                brandName: brandName,
                message: message,
                type: type,
                data: data,
            }, false);

            if(errorCallback && typeof errorCallback === 'function'){

                errorCallback(null, null, false);
            }

            return;
            break;
    }

    if(Object.keys(recordingOptions).length !== 0 && recordingOptions.hasOwnProperty('specificFolder') && recordingOptions['specificFolder'] !== ''){

        endpoint = recordingOptions.specificFolder + '/' + endpoint;
    }

    var request                 = new XMLHttpRequest();
    var clientData              = this.__getClientData(clientDataParamsToNotInclude);
    var environment             = this.__getEnvironment() == 'live' ? 'lv' : this.__getEnvironment(); 
    var brandName               = this.__getBrandName();
    var url                     = `${this.__baseUrl}/${brandName}/${endpoint}?environment=${environment}&type=${type}&time=${Date.now()}`;
    
    if(includeChosenAdSetup){

        var chosenAdSetup           = this.__getChosenAdSetup();
        var chosenAdSetupKeyDetails = this.__getChosenAdSetupKeyDetails();
        chosenAdSetup['info']       = chosenAdSetupKeyDetails;
    }

    if(isSendingErrorTelemetry){

        data = this.__prepareObjectForTransport(data);
    }
    
    clientData.gamId = this.__getPageGamId();
    clientData.boost = this.__isPageBoosted();

    if(clientDataParamsToNotInclude.indexOf('sessionId') == -1){

        clientData.s = this.__sessionId;
    }
    

    var postData = {
        v: '2',
        clnt: clientData,
        data: data,
    };

    if(includeChosenAdSetup){

        postData['chsn'] = chosenAdSetup;
    }

    if(includeMessage){

        postData['msg'] = message;
    }

    var encodedPostData = this.__encodeMessageBody(postData);

    if(!encodedPostData){

        delete postData['data'];

        var encodedPostData = this.__encodeMessageBody(postData);
    }

    // URL encode the post data. This allows for easy parsing of data in the backend.
    try{

        encodedPostData = encodeURIComponent(encodedPostData);
    }
    catch(error){

        this.__logger.error('Unable to encode post data.', {
            encodedPostData: encodedPostData,
            postData: postData,
            error: error,
        }, false);

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(null, null, false);
        }

        return;
    }

    if(useBeacon){

        this.__sendByBeacon(url, encodedPostData, successCallback, errorCallback);

        return;
    }

    request.onload = function(){

        if(request.status > 299){

            if(errorCallback && typeof errorCallback === 'function'){

                errorCallback(request.status, request.response, false);
            }

            return;
        }

        if(successCallback && typeof successCallback === 'function'){

            successCallback(request.response);
        }
    };

    request.onerror = function(event){

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(request.status, request.response, false);
        }
    };

    request.open('POST', url, true);
    request.send(encodedPostData);
};

//
// Send by beacon.
ANTelemetry.prototype.__sendByBeacon = function(url, encodedPostData, successCallback, errorCallback){
    
    if(!url){

        this.__logger.error('Unable to send data by beacon: missing url.', {
            encodedPostData: encodedPostData,
            postData: postData,
            url: url,
        }, false);  

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(null, null, false);
        }

        return;
    }

    var blob   = new Blob([encodedPostData], {type: 'text/plain'});
    var result = false;

    if(!blob){
        
        result = navigator.sendBeacon(url);
    }
    else{

        result = navigator.sendBeacon(url, blob);
    }

    if(!result){

        this.__logger.error('Unable to send data by beacon.', {
            encodedPostData: encodedPostData,
            postData: postData,
            url: url,
            result: result,
        }, false);

        if(errorCallback && typeof errorCallback === 'function'){

            errorCallback(null, null, false);
        }
    }
    else if(successCallback && typeof successCallback === 'function'){

        successCallback(result);
    }
}

//
// Prepare data for transport.
ANTelemetry.prototype.__prepareObjectForTransport = function(obj){
    
    if(!obj || typeof obj !== 'object'){

        return {};
    }

    var keys = Object.keys(obj);

    for(var x in keys){

        if(obj[keys[x]] instanceof Error){

            obj[keys[x]] = this.__prepareError(obj[keys[x]]);
        }
        else if(typeof keys[x] === 'object'){

            obj[keys[x]] = this.__prepareObjectForTransport(obj[keys[x]]);
        }
    }

    return obj;
}

//
// Prepare error object.
ANTelemetry.prototype.__prepareError = function(error){

    var errorAsObject = {};

    if(!error || typeof error !== 'object' || typeof error.toString !== 'function'){

        return errorAsObject;
    }

    errorAsObject['message'] = error.toString();

    if(error.hasOwnProperty('stack')){

        errorAsObject['stack'] = error.stack;
    }

    errorAsObject['data'] = {};

    // If error is an instance of AdError, add more information.
    if(typeof error.getErrorCode === 'function'){

        errorAsObject['data']['errorCode'] = error.getErrorCode();
    }

    if(typeof error.getErrorMessage === 'function'){

        var innerError = error.error.getInnerError();

        if(innerError){

            innerError = this.__prepareError(innerError);
        }

        errorAsObject['data']['innerError'] = innerError;
    }

    if(typeof error.getMessage === 'function'){

        errorAsObject['data']['message'] = error.getMessage();
    }

    if(typeof error.getType === 'function'){

        errorAsObject['data']['type'] = error.getType();
    }

    if(typeof error.getVastErrorCode === 'function'){

        errorAsObject['data']['vastErrorCode'] = error.getVastErrorCode();
    }

    return errorAsObject;
};

//
// Circular JSON replacer.
// TODO: Move this to a helper file could be used by other classes.
ANTelemetry.prototype.__getCircularReplacer = function(){

    var ancestors = [];

    return function(key, value){

        if(typeof value !== "object" || value === null){

            return value;
        }

        // `this` is the object that value is contained in, i.e., its direct parent.
        while(ancestors.length > 0 && ancestors[ancestors.length - 1] !== this){

            ancestors.pop();
        }

        for(var i = 0; i < ancestors.length; i++){

            if(ancestors[i] === value){

                return "[Circular]";
            }
        }

        ancestors.push(value);

        return value;
    };
}

window.ANTelemetry = ANTelemetry;